import { Loader as AanzetLoader } from "../../AanZet/custom_components/components/loader";
import { Loader as DNBLoader } from "../../DeNieuweBibliotheek/custom_components/components/loader";
import { Loader as GenericLoader } from "../../Generic/custom_components/components/loader";
import { getConfig } from "./featureSwitch";
const loaderConfig = {
    vbp: GenericLoader,
    aanzet: AanzetLoader,
    bkw: GenericLoader,
    dnb: DNBLoader,
    flevo: GenericLoader,
    rdam: GenericLoader,
    twente: GenericLoader
};
export const getLoader = getConfig(loaderConfig);
